import { useNftx, useTransaction } from '@nftx/react';
import useInfrastructure from '../../useInfrastructure';
import { SwapPrice } from '@/core/swap';

const useProcessTrade = () => {
  const {
    swap: { processTrade },
  } = useInfrastructure();
  const { provider, signer, network } = useNftx();

  return useTransaction(
    ({ quote }: { quote: SwapPrice }) => {
      return processTrade({ network, provider, quote, signer });
    },
    {
      description: 'Swap',
    }
  );
};

export default useProcessTrade;
